import React from 'react';
import { Stack } from '@mui/material';
import { withStyles } from '@material-ui/core';
import MaterialIcon from '../../Venti-UI-Kit/VIcon/MaterialIcon';
import styles from './styles';

const DraggableListItem = ({ classes, item, RenderItem }) => {
  return (
    <Stack direction="row" className={classes.draggableItemContainer}>
      <MaterialIcon
        name="drag_indicator"
        id="draggableListIcon"
        className={classes.dragHandleIcon}
      />
      <RenderItem item={item} />
    </Stack>
  );
};

export default withStyles(styles)(DraggableListItem);
